/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
/**
 * Internal dependencies
 */

import edit from './edit';
import icon from './icon';
var metadata = {
  name: "core/subhead",
  category: "common",
  attributes: {
    align: {
      type: "string"
    },
    content: {
      type: "string",
      source: "html",
      selector: "p"
    }
  }
};
import save from './save';
import transforms from './tranforms';
var name = metadata.name;
export { metadata, name };
export var settings = {
  title: __('Subheading (deprecated)'),
  description: __('This block is deprecated. Please use the Paragraph block instead.'),
  icon: icon,
  supports: {
    // Hide from inserter as this block is deprecated.
    inserter: false,
    multiple: false
  },
  transforms: transforms,
  edit: edit,
  save: save
};
//# sourceMappingURL=index.js.map